import { render, staticRenderFns } from "./v2_mobile.vue?vue&type=template&id=078e4c4f&scoped=true&"
import script from "./v2_mobile.vue?vue&type=script&lang=js&"
export * from "./v2_mobile.vue?vue&type=script&lang=js&"
import style0 from "./v2_mobile.vue?vue&type=style&index=0&id=078e4c4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078e4c4f",
  null
  
)

export default component.exports